import { render } from "./JobStackDeploymentDetailsEdit.vue?vue&type=template&id=bc04e506&scoped=true"
import script from "./JobStackDeploymentDetailsEdit.vue?vue&type=script&lang=js"
export * from "./JobStackDeploymentDetailsEdit.vue?vue&type=script&lang=js"

import "./JobStackDeploymentDetailsEdit.vue?vue&type=style&index=0&id=bc04e506&scoped=true&lang=css"
import "./JobStackDeploymentDetailsEdit.vue?vue&type=style&index=1&id=bc04e506&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc04e506"]])

export default __exports__